import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15f6bda5")

_pushScopeId("data-v-15f6bda5")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 row" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "fs-6 fw-bold mb-1 text-center" }
const _hoisted_11 = { class: "input-item el-input__inner" }
const _hoisted_12 = { class: "align-items-center fs-6 fw-bold text-wrapper" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-upload",
  style: {"text-align":"right","float":"right"}
}, null, -1)
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = /*#__PURE__*/_createVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, null, -1)
const _hoisted_18 = { class: "col-md-12 mt-7" }
const _hoisted_19 = { class: "card" }
const _hoisted_20 = { class: "card-header card-p border-0 pt-0" }
const _hoisted_21 = { class: "card-title align-items-start flex-column" }
const _hoisted_22 = { class: "card-label fw-bolder fs-3" }
const _hoisted_23 = { class: "card-body p-0" }
const _hoisted_24 = { class: "table-responsive" }
const _hoisted_25 = {
  key: 0,
  class: "fs-6"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_27 = { class: "menu-item-wrapper" }
const _hoisted_28 = { class: "menu-item" }
const _hoisted_29 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-edit" })
], -1)
const _hoisted_30 = { class: "menu-item" }
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Input = _resolveComponent("Input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_InnerLoader, {
      loading: _ctx.loading,
      innerLoading: true
    }, null, 8, ["loading"]),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Select, {
            name: "attribute",
            target: "attribute",
            callEmit: true,
            label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.ATTRIBUTES')}`,
            placeholder: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.ATTRIBUTES')}`,
            attribute: _ctx.attribute,
            "onUpdate:attribute": _cache[1] || (_cache[1] = ($event: any) => (_ctx.attribute = $event)),
            selectData: _ctx.attributes,
            value: _ctx.attribute,
            onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeAttribute(_ctx.attribute, null)))
          }, null, 8, ["label", "placeholder", "attribute", "selectData", "value"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_Select, {
            name: "attributeValue",
            target: "attributeValue",
            label: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.VARIATION')}`,
            placeholder: `${_ctx.$t('message.SELECT')} ${_ctx.$t('message.VARIATION')}`,
            attributeValue: _ctx.attributeValue,
            "onUpdate:attributeValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.attributeValue = $event)),
            selectData: _ctx.attributeValues,
            value: _ctx.attributeValue,
            callEmit: true,
            onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeAttribute(_ctx.attributeValue, 'exitsVariation')))
          }, null, 8, ["label", "placeholder", "attributeValue", "selectData", "value"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Input, {
            type: "number",
            name: "attributePrice",
            label: `${_ctx.$t('message.PRICE')}`,
            placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PRICE')}`,
            attributePrice: _ctx.attributePrice,
            "onUpdate:attributePrice": _cache[5] || (_cache[5] = ($event: any) => (_ctx.attributePrice = $event)),
            target: "attributePrice",
            value: _ctx.attributePrice
          }, null, 8, ["label", "placeholder", "attributePrice", "value"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Input, {
            type: "text",
            name: "attributeSku",
            label: `${_ctx.$t('message.SKU')}`,
            placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.SKU')}`,
            attributeSku: _ctx.attributeSku,
            "onUpdate:attributeSku": _cache[6] || (_cache[6] = ($event: any) => (_ctx.attributeSku = $event)),
            target: "attributeSku",
            value: _ctx.attributeSku
          }, null, 8, ["label", "placeholder", "attributeSku", "value"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Input, {
            type: "text",
            name: "attributeProductNumber",
            label: `${_ctx.$t('message.PRODUCT_NUMBER')}`,
            placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.PRODUCT_NUMBER')}`,
            attributeProductNumber: _ctx.attributeProductNumber,
            "onUpdate:attributeProductNumber": _cache[7] || (_cache[7] = ($event: any) => (_ctx.attributeProductNumber = $event)),
            target: "attributeProductNumber",
            value: _ctx.attributeProductNumber
          }, null, 8, ["label", "placeholder", "attributeProductNumber", "value"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Input, {
            type: "number",
            name: "stock",
            label: `${_ctx.$t('message.STOCK')}`,
            placeholder: `${_ctx.$t('message.ENTER')} ${_ctx.$t('message.STOCK')}`,
            requiredMsg: `${_ctx.$t('message.NAME')} ${_ctx.$t('message.IS_REQUIRED')}`,
            stock: _ctx.stock,
            "onUpdate:stock": _cache[8] || (_cache[8] = ($event: any) => (_ctx.stock = $event)),
            target: "stock",
            value: _ctx.stock
          }, null, 8, ["label", "placeholder", "requiredMsg", "stock", "value"])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('message.THUMBNAIL')), 1),
          _createVNode("div", _hoisted_11, [
            _createVNode("label", _hoisted_12, [
              (_ctx.imageLabel == '')
                ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('message.CHOOSE')) + " " + _toDisplayString(_ctx.$t('message.IMAGE')), 1))
                : (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.imageLabel), 1))
            ]),
            _createVNode(_component_el_button, {
              type: "info",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.triggerFile())),
              plain: "",
              class: "px-2 py-2  mx-1 btn-custom"
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('message.UPLOAD')) + "   ", 1),
                _hoisted_15
              ]),
              _: 1
            })
          ]),
          _createVNode("input", {
            type: "file",
            class: "form-control",
            ref: "inputFile",
            style: {"display":"none"},
            accept: "image/png, image/jpg, image/jpeg",
            onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.variationImageHandler && _ctx.variationImageHandler(...args))),
            id: "customFile"
          }, null, 544)
        ]),
        _createVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_el_button, {
            type: "primary",
            class: "mt-2 btn-custom",
            disabled: _ctx.disabled,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.variationHandler())),
            style: {"float":"right"}
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.variation_id == undefined ? _ctx.$t('message.SAVE') : _ctx.$t('message.UPDATE')), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("div", _hoisted_19, [
            _createVNode("div", _hoisted_20, [
              _createVNode("h3", _hoisted_21, [
                _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('message.COMBINATIONS')) + " " + _toDisplayString(_ctx.$t('message.LIST')), 1)
              ])
            ]),
            _createVNode("div", _hoisted_23, [
              _createVNode("div", _hoisted_24, [
                _createVNode(_component_Table, {
                  columns: _ctx.columns,
                  rows: _ctx.variations,
                  padding: 5
                }, {
                  "cell-attribute_value": _withId(({row:item}) => [
                    (item.attribute_value_type == 'Size' || item.attribute_value_type == 'Weight')
                      ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(item.attribute_value), 1))
                      : (_openBlock(), _createBlock("span", {
                          key: 1,
                          class: "fs-6 variation-color",
                          style: {
                                            background: item.attribute_value,
                                            color: item.attribute_value
                                        }
                        }, _toDisplayString(item.attribute_value_type), 5))
                  ]),
                  "cell-actions": _withId(({row:item , index:index}) => [
                    _createVNode("button", {
                      class: "action-btn",
                      type: "button",
                      onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
                    }, [
                      _hoisted_26,
                      _createVNode("div", {
                        class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
                      }, [
                        _createVNode("div", _hoisted_27, [
                          _createVNode("div", _hoisted_28, [
                            _createVNode("a", {
                              onClick: ($event: any) => (_ctx.handleEdit(item, index)),
                              class: "menu-link me-1"
                            }, [
                              _hoisted_29,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.EDIT')), 1)
                            ], 8, ["onClick"])
                          ]),
                          _createVNode("div", _hoisted_30, [
                            _createVNode("a", {
                              onClick: ($event: any) => (_ctx.handleDelete(index)),
                              class: "menu-link me-1"
                            }, [
                              _hoisted_31,
                              _createTextVNode(" " + _toDisplayString(_ctx.$t('message.DELETE')), 1)
                            ], 8, ["onClick"])
                          ])
                        ])
                      ], 2)
                    ], 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["columns", "rows"])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
})